// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Pages
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import AppCredential from "../AppCredential/AppCredential";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Recoil
import { useRecoilState } from "recoil";
import { activeAutom } from "../../../../recoil-store/recoil-state";

function Message({ action, variables, setOpenVariable, automId, setAlert, automVersionId }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.MY-CHATGPT.MESSAGE.';

    return (
        <div>
            <AppCredential action={action} setAlert={setAlert}/>
            <div className="form-element">
                {t(label + 'MESSAGE')}
                <TextInput action={action} inputName="message" variables={variables}
                           setOpenVariable={setOpenVariable} multiline rows={4} fieldType="string"
                           displayName={t(label + 'MESSAGE')}/>
                <small
                    className="conf-field-desc"><em>{t(label + 'MESSAGE-HELPER', {type: 'string'})}</em></small>
            </div>
        </div>
    );
}

export default Message;
